/**
 * @desc 库容列表概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.MaterialStorageDTO>>> {
  return defHttp.post({
    url: '/web/materialManage/overview',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.MaterialStorageDTO>>> {
  return defHttp.post({
    url: '/mock/web/materialManage/overview',
  });
}
